/**
 * «MANCA ANCORA» IN EVIDENZA (29 ott 2026, Davide: «puoi evidenziare, dove sta Aggiungi al carrello, quello che manca
 * per configurare il gioiello?»).
 * Il riquadro prezzo lo disegna l'App Builder dal testo Markdown del modello Grasshopper (prezzo_grasshopper.py /
 * prezzo_sagoma.py): finche' la configurazione non e' completa l'ultima riga dice «**Manca ancora:** il segnaposto.»
 * e il pulsante "Aggiungi al carrello" non c'e'. Quella riga era un testo come gli altri: qui le si da' la classe
 * "eidos-manca" (stile in totem.css: riquadro ottanio chiaro con bordo a sinistra), cosi' il cliente vede subito cosa
 * gli resta da scegliere. Il riquadro viene ridisegnato a ogni calcolo: si ricontrolla a ogni cambiamento della pagina
 * (al massimo una volta ogni 150 ms, come per "Salva tagli").
 */
const CLASSE = "eidos-manca";
const INIZIO = /^\s*manca ancora\b/i;

function segna(): void {
	const testi = document.querySelectorAll<HTMLElement>('[class*="markdownNormalize"]');
	for (const testo of testi) {
		for (const forte of testo.querySelectorAll<HTMLElement>("strong, b")) {
			if (!INIZIO.test(forte.textContent ?? "")) continue;
			const blocco = forte.closest<HTMLElement>("p, li, div");
			if (blocco && blocco !== testo && INIZIO.test(blocco.textContent ?? "")) {
				// caso normale: la riga e' un paragrafo a se' -> la classe va sul paragrafo
				blocco.classList.add(CLASSE);
			} else if (!forte.parentElement?.classList.contains(CLASSE)) {
				// riga dentro un paragrafo piu' lungo (a capo con <br>): si avvolge dal grassetto fino al prossimo a capo
				const span = document.createElement("span");
				span.className = CLASSE;
				forte.before(span);
				let n: ChildNode | null = forte;
				while (n && !(n instanceof HTMLBRElement)) {
					const dopo: ChildNode | null = n.nextSibling;
					span.appendChild(n);
					n = dopo;
				}
			}
		}
	}
}

export function avviaMancaAncora(): void {
	try {
		let attesa: number | undefined;
		const oss = new MutationObserver(() => {
			if (attesa !== undefined) return;
			attesa = window.setTimeout(() => {
				attesa = undefined;
				segna();
			}, 150);
		});
		oss.observe(document.body, {childList: true, subtree: true});
		segna();
	} catch (e) {
		console.warn("Eidos: evidenza di «Manca ancora» non attiva", e);
	}
}
